import { ZoomRenderer } from '@ikegps/core-shared';
import { Spinner } from '../../components/spinner/spinner';
import { T, Translate } from '../../i18n/index';
import { m, type MithrilVNode } from '../../mithril';
import { CurrentState } from '../../state/page.state';
import { CollectionMetaInfo } from './collection.meta.info/collection.meta.info';
import { CSS, ZOOM_HEIGHT, ZOOM_WIDTH } from './collection.view.style';
import { CollectionEditViewSubform } from './collection.view.subform';
import { CollectionEditViewTitle } from './collection.view.title';
import type { EditableCollectionController } from './collection.view.ctrl.interface';

export interface CollectionViewOptions {
	isEditable: boolean;
}
export class CollectionEdit {
	zoomRenderer: ZoomRenderer;

	constructor(public ctrl: EditableCollectionController) {
		this.zoomRenderer = new ZoomRenderer({
			zoomLevel: 2,
			size: {
				width: parseInt(ZOOM_WIDTH),
				height: parseInt(ZOOM_HEIGHT),
			},
			useCrosshair: true,
			crosshairCenterGap: 7.5,
		});
	}

	view(toggleableElement: MithrilVNode = null) {
		if (!this.ctrl.isCollectionSelected) {
			return null;
		}

		const collection = this.ctrl.collection;
		if (collection == null) {
			if (!this.ctrl.isCollectionLoading) {
				return m('div', { className: CSS.container + ' ' + CSS.isMissing }, Translate(T.COLLECTION_MISSING));
			}

			return m('div', { className: CSS.container + ' ' + CSS.isLoading }, m('span', Spinner.view()));
		}

		const containerElements = [
			CollectionEditViewTitle.view(this.ctrl),
			this.ctrl.isMetadataShown ? CollectionMetaInfo.view(collection) : null,
			this.ctrl.isPhotomeasure && this.ctrl.isZoomShown ? this.viewZoom() : null,
			CollectionEditViewSubform.view(this.ctrl, collection),
		];

		if (toggleableElement) {
			containerElements.push(toggleableElement);
		}

		return m('div', { className: CSS.container }, containerElements);
	}

	private viewZoom() {
		const zoomNode = this.zoomRenderer.view(CurrentState.CollectionEdit.currentDraw);
		return m('div', { className: CSS.zoom }, zoomNode != null ? zoomNode : Translate(T.SELECT_MEASUREMENT));
	}
}
